import React, { useState } from "react";
import {Container, Grid, Button, Box} from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';

const ScanQR = ({ isLoading, isScanned, isExpired, isScanning, isDisabled, qrCode, handleSession }) => {
    const setSession = (e) => {
      e.preventDefault()
      handleSession()
    }

    const setReload = () => {
      window.location.reload()
    }

  
    return (
      <Container>
        <Grid container style={{justifyContent: "center", flexDirection: "column", alignItems:"center", height:'300px'}}>
            <Grid className="text-center">
              {
                isLoading ?
                <Box sx={{ display: 'flex' }}>
                  <CircularProgress />
                </Box>
                :
                isScanned ?
                <img style={{width: "140px", height: "140px", objectFit: "cover", border: "2px solid #dadada", display:'flex', justifyContent:'center'}} width="150px" src='/Successful QR Code.png' alt="qr code"/>
                :
                isExpired ?
                <img style={{width: "140px", height: "140px", objectFit: "cover", border: "2px solid #dadada", display:'flex', justifyContent:'center'}} width="150px" src='/Expire QR Code.png' alt="qr code" onClick={setReload}/>
                :
                isScanning ?
                <img style={{width: "140px", height: "140px", objectFit: "cover", border: "2px solid #dadada", display:'flex', justifyContent:'center'}} width="150px" src={qrCode} alt="qr code"/>
                :
                <div  style={{alignItems:'center', justifyContent:'center'}}>
                  <h1 className="text-grey font-size-10" style={{display:'flex', justifyContent:'center'}}>Klik Tombol Generate QR Code</h1>
                  <h1 className="text-grey font-size-10" style={{display:'flex', justifyContent:'center'}}>Untuk Memunculkan QR Code</h1>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isDisabled? true : false}
                    className={isDisabled? "font-size-5 btn-grey text-transform-unset" : "font-size-5 btn-black text-transform-unset" }
                    style={{padding: "1px 10px"}}
                    onClick={setSession}
                    >
                    Generate QR Code
                  </Button>
                </div>
              }
            </Grid>
        </Grid>
      </Container>
    );
}

export default ScanQR